import React, { useState } from "react";
import { Box, IconButton, Link, Modal, Typography } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import InsertDriveFileIcon from "@mui/icons-material/InsertDriveFile";
import ImageNotSupportedIcon from "@mui/icons-material/ImageNotSupported";
import { pickVideoChatMedia } from "./videoChatThread";

function VideoChatMedia({ message, openFileLabel = "Abrir arquivo" }) {
  const [imageError, setImageError] = useState(false);
  const [imageOpen, setImageOpen] = useState(false);
  const media = pickVideoChatMedia(message);
  if (!media.mediaUrl) return null;

  if (media.messageType === "image") {
    return (
      <>
        {imageError ? (
          <ImageNotSupportedIcon sx={{ fontSize: 48, color: "#9aa0a6" }} />
        ) : (
          <Box
            component="img"
            src={media.mediaUrl}
            alt={media.fileName || "Imagem"}
            onClick={() => setImageOpen(true)}
            onError={() => setImageError(true)}
            sx={{
              display: "block",
              width: "100%",
              maxWidth: "100%",
              maxHeight: 240,
              height: "auto",
              objectFit: "contain",
              borderRadius: 1.5,
              cursor: "pointer",
            }}
          />
        )}
        <Modal
          open={imageOpen}
          onClose={() => setImageOpen(false)}
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            p: 2,
            boxSizing: "border-box",
          }}
        >
          <Box
            sx={{ position: "relative", outline: "none", maxWidth: "100%", maxHeight: "100%" }}
            onClick={() => setImageOpen(false)}
          >
            <IconButton
              onClick={(e) => {
                e.stopPropagation();
                setImageOpen(false);
              }}
              aria-label="Fechar"
              sx={{
                position: "fixed",
                top: 12,
                right: 12,
                color: "#fff",
                bgcolor: "rgba(0,0,0,0.45)",
                "&:hover": { bgcolor: "rgba(0,0,0,0.65)" },
              }}
            >
              <CloseIcon />
            </IconButton>
            <Box
              component="img"
              src={media.mediaUrl}
              alt={media.fileName || "Imagem"}
              onClick={(e) => e.stopPropagation()}
              sx={{
                maxWidth: "calc(100dvw - 32px)",
                maxHeight: "calc(100dvh - 32px)",
                objectFit: "contain",
                borderRadius: 1,
                display: "block",
              }}
            />
          </Box>
        </Modal>
      </>
    );
  }

  if (media.messageType === "video") {
    return (
      <Box
        component="video"
        src={media.mediaUrl}
        controls
        playsInline
        preload="metadata"
        sx={{
          display: "block",
          width: "100%",
          maxWidth: "100%",
          maxHeight: 240,
          borderRadius: 1.5,
          bgcolor: "#000",
        }}
      />
    );
  }

  if (media.messageType === "audio") {
    return (
      <Box
        component="audio"
        src={media.mediaUrl}
        controls
        preload="metadata"
        sx={{
          display: "block",
          width: "100%",
          maxWidth: "100%",
          height: 36,
        }}
      />
    );
  }

  return (
    <Box
      component={Link}
      href={media.mediaUrl}
      target="_blank"
      rel="noopener noreferrer"
      underline="none"
      sx={{
        display: "flex",
        alignItems: "center",
        gap: 1,
        minWidth: 0,
        maxWidth: "100%",
        px: 1,
        py: 0.85,
        borderRadius: 1.5,
        bgcolor: "rgba(255,255,255,0.08)",
        color: "#e8eaed",
        "&:hover": { bgcolor: "rgba(255,255,255,0.12)" },
      }}
    >
      <InsertDriveFileIcon sx={{ fontSize: 22, color: "#aecbfa", flexShrink: 0 }} />
      <Box sx={{ minWidth: 0 }}>
        <Typography noWrap sx={{ fontSize: "0.82rem", fontWeight: 600 }}>
          {media.fileName || "Arquivo"}
        </Typography>
        <Typography sx={{ fontSize: "0.68rem", color: "#9aa0a6" }}>{openFileLabel}</Typography>
      </Box>
    </Box>
  );
}

export default VideoChatMedia;
